<div [class]="this.bordercolor">
  <table>
    <tr>

      <td>
        {{this.Injury.BodyAreaName}}/{{this.Injury.BodyPartName}}&nbsp;({{this.Injury.Side}})
      </td>
      <td >
        {{this.Injury.TypeName}}
      </td>
      <td>

      </td>
      <td>  {{this.Injury.InjuryDays}} days</td>
    </tr>
    <tr>

      <td class="minortext" colspan="3"> {{this.Injury.InjuryDate | date:'yyyy-MM-dd'}} -  {{this.Injury.ActualReturnDate | date:'yyyy-MM-dd'}} @if (this.Injury.EstimatedReturnDate!=null) {
        <span style="color:gray;">({{this.Injury.EstimatedReturnDate | date:'yyyy-MM-dd'}})</span>
      }</td>

      <td>

      </td>
    </tr>


    <tr>
      <td  class="smalltitle">
        Trauma
      </td>
      <td class="smalltitle">
        Conditiion
      </td>
      <td class="smalltitle">
        Location
      </td>
      <td class="smalltitle">

      </td>
    </tr>
    <tr>
      <td  class="value">
        @if (this.Injury.Trauma) {
          <span>YES</span>
        }
        @if (!this.Injury.Trauma) {
          <span>NO</span>
        }
      </td>
      <td  class="value">
        {{this.Injury.ConditionName}} &nbsp;
      </td>
      <td  class="value">
        {{this.Injury.LocationName}}
      </td>
      <td  class="value">

      </td>
    </tr>
    @if (this.Injury.Description!=null) {
      <tr>
        <td class="smalltitle">
          Description
        </td>
        <td>
        </td>
      </tr>
    }
    @if (this.Injury.Description!=null) {
      <tr>
        <td class="value" colspan="4">
          {{this.Injury.Description}}
        </td>
        <td>
        </td>
      </tr>
    }
  </table>
  <button mat-button [routerLink]="'/injury/edit/' + this.Injury.InjuryId">EDIT</button>

</div>